var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isGranted('ADD_CLIENT'))?_c('q-btn',_vm._b({attrs:{"color":"primary","icon":"fa fa-plus"},on:{"click":_vm.openModal}},'q-btn',_vm.$attrs,false),[_vm._t("default",[_c('span',{staticClass:"q-ml-sm"},[_vm._v("Add Client")])])],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }